import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { EVENT_ACTIONS, EVENT_CATEGORIES } from '../../modules/analytics/components/Event';
import ContactElement from '../ContactElement';
var Email = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Email, _React$PureComponent);
  var _super = _createSuper(Email);
  function Email() {
    _classCallCheck(this, Email);
    return _super.apply(this, arguments);
  }
  _createClass(Email, [{
    key: "getEmailLink",
    value: function getEmailLink() {
      var email = this.props.email;
      return "mailto:".concat(email, ";").toLowerCase();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        email = _this$props.email,
        as = _this$props.as,
        header = _this$props.header,
        iconPosition = _this$props.iconPosition,
        showIcon = _this$props.showIcon,
        buttonColor = _this$props.buttonColor,
        className = _this$props.className,
        fluidButton = _this$props.fluidButton,
        buttonSize = _this$props.buttonSize;
      if (!email) {
        return null;
      }
      return /*#__PURE__*/React.createElement(ContactElement, {
        contact: email,
        link: this.getEmailLink(),
        iconType: showIcon || as === 'icon' ? 'mail' : 'none',
        as: as,
        iconPosition: iconPosition,
        header: header,
        className: className,
        buttonColor: buttonColor,
        fluidButton: fluidButton,
        buttonSize: buttonSize,
        event: {
          category: EVENT_CATEGORIES.CONTACT_EVENT_CATEGORY,
          action: EVENT_ACTIONS.CONTACT_EMAIL_EVENT_ACTION
        }
      });
    }
  }]);
  return Email;
}(React.PureComponent);
export { Email as default };
Email.defaultProps = {
  as: 'text',
  buttonColor: 'default',
  buttonSize: 'large',
  className: '',
  fluidButton: false,
  header: '',
  iconPosition: 'left',
  showIcon: false
};
Email.propOptions = {
  buttonColor: ['primary', 'secondary', 'default'],
  header: ['Email', 'Our Email', ''],
  iconPosition: ['left', 'right', 'top', 'bottom']
};
Email.propsDataMap = {
  email: ['business', 'primary_location', 'email']
};